export default "__VITE_ASSET__BiaczR3$__"